"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeStorageAdapter = void 0;
class FakeStorageAdapter {
    uploadToSignedUrl(file, key, uploadHandler, onUploadProgress, onUploadSuccess, onUploadError, isThumbnail) {
        throw new Error("Method not implemented.");
    }
}
exports.FakeStorageAdapter = FakeStorageAdapter;
